export enum IconAlignment {
    Screen = "Screen",
    North = "North"
}